module.exports = __webpack_public_path__ + "media/images/ruler-b73f370dbc1870fca98de231f7f31433.svg";